<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="cssLayoutRowStartCenter">
  <div class="sp-icon">
    <mat-icon class="mdi-24px" fontIcon="mdi-clipboard" [ngStyle]="{ color: 'var(--mat-sys-primary)' }"
      alt="Event Templates"></mat-icon>
  </div>
  <mat-form-field class="search-field">
    <input matInput [formControl]="filterControl" placeholder="Search" />
    @if (filterControl.value) {
    <button mat-icon-button matSuffix (click)="clearFilter()" title="Clear Search">
      <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
    }
  </mat-form-field>
  <div class="nator-div">
    <mat-paginator #paginator [pageSize]="20"
      [pageSizeOptions]="[5, 10, 15, 20, 25, 50, 100, 200]"></mat-paginator>
  </div>
</div>

<div class="table-container">
  <table mat-table [dataSource]="eventTemplateDataSource" matSort matSortActive="dateCreated"
    matSortDirection="desc" multiTemplateDataRows>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        @if (canCreateEventTemplates()) {
        <button mat-icon-button (click)="addNewEventTemplate(); $event.stopPropagation()"
          style="outline: none; margin-left: 20px;" title="Add Event Template">
          <mat-icon class="mdi-24px" fontIcon="mdi-plus-circle"></mat-icon>
        </button>
        }
      </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button (click)="editEventTemplate(element); $event.stopPropagation()"
          title="{{ (canEditEventTemplate(element.id) || canManageEventTemplate(element.id)) ? 'Edit' : 'View' }}: {{ element.name }}">
          <mat-icon class="mdi-18px"
            [fontIcon]="(canEditEventTemplate(element.id) || canManageEventTemplate(element.id)) ? 'mdi-square-edit-outline' : 'mdi-eye-outline'"></mat-icon>
        </button>
        <button mat-icon-button ngxClipboard [cbContent]="element.id" (click)="$event.stopPropagation()"
          title="Copy: {{ element.id }}">
          <mat-icon class="mdi-18px" fontIcon="mdi-content-copy"></mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
      <td mat-cell *matCellDef="let element" title="{{ element.description }}">{{
        element.description && element.description.length > 80
        ? element.description.slice(0, 80) + ' ...'
        : element.description
        }}</td>
    </ng-container>

    <ng-container matColumnDef="durationHours">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Duration (Hours)</th>
      <td mat-cell *matCellDef="let element">{{ element.durationHours }}</td>
    </ng-container>

    <ng-container matColumnDef="dateCreated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
      <td mat-cell *matCellDef="let element">{{ element.dateCreated | date: 'yyyy-MM-dd' }}</td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        <div [@detailExpand]="element.id === expandedEventTemplateId ? 'expanded' : 'collapsed'"
          (click)="$event.stopPropagation()">
          @if (element.id === expandedEventTemplateId) {
          <div class="memberships-container">
            <label class="memberships-label">Memberships</label>
            <app-event-template-memberships [eventTemplateId]="element.id"
              [showHeader]="false"></app-event-template-memberships>
          </div>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row"
      (click)="selectEventTemplate(row.id)"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
  </table>
</div>

@if (isLoading) {
<div>
  <div flex>
    <mat-progress-spinner color="accent" mode="indeterminate">
    </mat-progress-spinner>
  </div>
</div>
}
